import { Injectable } from '@angular/core';
import { ITeamDto } from 'core/dto';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudBasicMethods } from './types/i-crud-basic.methods';


@Injectable({ providedIn: 'root' })
export class TeamRemoteControllerService implements Pick<ICrudBasicMethods<ITeamDto>, 'getOne' | 'create' | 'update' | 'remove'> {

  private readonly _endpoint = controllerEndpoints.TEAM
  private readonly USER = 'user'

  constructor(
    private readonly _apiService: ApiService
  ) {

  }



  getMany(options: { page: number, size: number, sort: string[] }) {
    return this._apiService.get<ITeamDto[]>(this._endpoint, options)
  }

  getOne(id: string) {

    const getOneEndpoint = joinUrls(this._endpoint, id)
    return this._apiService.get<ITeamDto>(getOneEndpoint)
  }


  getByUserId(userId: string) {
    const getByUserIdPath = joinUrls(this._endpoint, this.USER, userId)
    return this._apiService.get<ITeamDto[]>(getByUserIdPath)
  }

  create(createDto: Partial<ITeamDto>): Observable<ITeamDto> {

    return this._apiService.post<ITeamDto>(this._endpoint, createDto);
  }

  update(id: string, updateDto: Partial<ITeamDto>): Observable<ITeamDto> {

    return this._apiService.put<ITeamDto>(joinUrls(this._endpoint, id), updateDto);
  }

  remove(id: string) {
    return this._apiService.delete<ITeamDto>(joinUrls(this._endpoint, id));
  }
} 
